import axios, { AxiosInstance } from 'axios';
import {
  Tokens,
  getTokensLocalStorage,
  setTokensLocalStorage,
} from '../requests';

function api(withRefreshToken = false): AxiosInstance {
  const tokens = getTokensLocalStorage() as Tokens;

  const token = withRefreshToken ? tokens?.refresh_token : tokens?.access_token;

  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_API_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  axiosInstance.interceptors.response.use(
    response => response,
    async error => {
      if (error.response && error.response.status === 401) {
        const path = window.location.pathname;

        const isAuthOrRecoverPassword =
          path === '/' || path.includes('recover-password');

        if (!isAuthOrRecoverPassword) {
          setTokensLocalStorage(null);
        }
      }
      return Promise.reject(error);
    },
  );

  return axiosInstance;
}

export default api;
